export default __webpack_public_path__ + "static/google-play-badge-34b0ffe8dc009d4608a048e5497dac28.png";